import { render } from "./SocialsList.vue?vue&type=template&id=ad5debfe&scoped=true"
import script from "./SocialsList.vue?vue&type=script&lang=js"
export * from "./SocialsList.vue?vue&type=script&lang=js"

import "./SocialsList.vue?vue&type=style&index=0&id=ad5debfe&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad5debfe"]])

export default __exports__